<template>
  <a-spin :spinning="!this.chartData">
    <h3>Import Export of population aging countries</h3>
    <div class="commands">
            <span class="filter" id="export">Trade export</span>
            <span class="filter" id="import">Trade import</span>
        </div>
           <div class="commands">
            <span class="filter_y" id="y_2000">2000 year</span>
            <span class="filter_y" id="y_2004">2004 year</span> 
            <span class="filter_y" id="y_2008">2008 year</span> 
            <span class="filter_y" id="y_2011">2011 year</span>
            <span class="filter_y" id="y_2015">2015 year</span>  
            <span class="filter_y" id="y_2018">2018 year</span>
        </div>
    <div class="commands">
        <span class="sort" id="country">Country</span>
		<span class="sort" id="value">Trade value</span>	
	</div>
    <div id="import-export-chart"></div>
  </a-spin>
</template>
<script>
import * as d3 from "d3";
import axios from "axios";
export default {
    name: "ExpImpChart",
    data: function(){
        return{
            chartData: null,
        };
    },
    mounted(){
        // console.log("chart2");
        const API = this.$store.state.API;
    if (!this.$store.state.ExpImpData) {
      axios.get(`${API}affect/ExpImp.json`).then(result => {
        this.chartData = result.data;  
        // console.log('chartData set from file');
        // console.log('chartData contains', this.chartData.length, 'rows');
        this.$store.commit('ExpImpData', result.data);
        this.makeEIChart();
        })
    } else {
      this.chartData = this.$store.state.ExpImpData;
      // console.log('chartData set from store');
      // console.log('chartData contains', this.chartData.length, 'rows');
      this.makeEIChart();
    }},
    methods:{
        makeEIChart(){
            var margin = { top: 20, left: 55, bottom: 50, right: 150 },
				width = 650 - margin.left - margin.right,
                height = 500 - margin.top - margin.bottom;
                var svg = d3.select('#import-export-chart')
				.append('svg')
				.attr('width', width + margin.left + margin.right)
				.attr('height', height + margin.top + margin.bottom)
				.append('g')
                .attr('transform', 'translate(' + margin.left + ', ' + margin.top + ')');   
        var y = d3.scaleBand();
        var x = d3.scaleLinear();
        var delay = function (d, i) {
				return i * 50;
            };    
        
        var current, sortMode ='#country', fiterMode;
        var yAxis;
        var sls_year_id;
           const EIData = JSON.parse(JSON.stringify(this.chartData));
            var y_2000 = [], y_2004 = [], y_2008 = [], y_2011 = [], y_2015 = [], y_2018 = [];
            for (var item of EIData){
                if(item.year == 2000){
                    y_2000.push(item);
                    sls_year_id = '#y_2000';
                }
                else if(item.year == 2004){
                    y_2004.push(item);
                    sls_year_id = '#y_2004';
                }
                else if(item.year == 2008){
                    y_2008.push(item);
                    sls_year_id = '#y_2005';
                }
                else if(item.year == 2011){
                    y_2011.push(item);
                    sls_year_id = '#y_2011';
                }
                else if(item.year == 2015){
                    y_2015.push(item);
                    sls_year_id = '#y_2015';
                }
                else if(item.year == 2018){
                    y_2018.push(item);
                    sls_year_id = '#y_2018';
                }
            }
            var sls_year = y_2000;
            
            filter('#export', y_2000);
            sort('#country');

            toggleFilter('#export');
            toggleFilter_y('#y_2000');
            toggleSort('#country');

            draw();
            d3.select('#country')
            .on('click',() =>{
                sort('#country');
                transition();
                toggleSort('#country');
            });

            d3.select('#value')
            .on('click', () =>{
                sort('#value');
                transition();
                toggleSort('#value');
            });
            
            d3.select('#y_2000')
            .on('click',() =>{
                sls_year = y_2000;
                filter(fiterMode, y_2000);
                sort(sortMode);
                redraw();
                
                toggleSort(sortMode);
                toggleFilter(fiterMode);
                toggleFilter_y('#y_2000');
                
                
            });
            d3.select('#y_2004')
            .on('click',() =>{
                sls_year = y_2004;
                filter(fiterMode, y_2004);
                sort(sortMode);
                // console.log(sortMode)
                toggleSort(sortMode);
                toggleFilter(fiterMode);
                toggleFilter_y('#y_2004');
                redraw();
            });
            d3.select('#y_2008')
            .on('click',() =>{
                sls_year = y_2008;
                filter(fiterMode, y_2008);
                sort(sortMode);
                // console.log(sortMode)
                toggleSort(sortMode);
                toggleFilter(fiterMode);
                toggleFilter_y('#y_2008');
                redraw();
            });
            d3.select('#y_2011')
            .on('click',() =>{
                sls_year = y_2011;
                filter(fiterMode, y_2011);
                sort(sortMode);
                // console.log(sortMode)
                toggleSort(sortMode);
                toggleFilter(fiterMode);
                toggleFilter_y('#y_2011');
                redraw();
            });
            d3.select('#y_2015')
            .on('click',() =>{
                sls_year = y_2015;
                filter(fiterMode, y_2015);
                sort(sortMode);
                // console.log(sortMode)
                toggleSort(sortMode);
                toggleFilter(fiterMode);
                toggleFilter_y('#y_2015');
                redraw();
            });
            d3.select('#y_2018')
            .on('click',() =>{
                sls_year = y_2018;
                filter(fiterMode, y_2018);
                sort(sortMode);
                // console.log(sortMode)
                toggleSort(sortMode);
                toggleFilter(fiterMode);
                toggleFilter_y('#y_2018');
                redraw();
            });
            d3.select('#import')
            .on('click', () =>{
                // console.log(sortMode)
                // console.log(sls_year)
                filter('#import', sls_year);
                sort(sortMode);
                // console.log(sortMode)
                toggleSort(sortMode);
                toggleFilter(fiterMode);
                toggleFilter_y(sls_year_id);
                redraw();
            });
            d3.select('#export')
            .on('click', () =>{
                filter('#export', sls_year);
                sort(sortMode);
                // console.log(sortMode)
                toggleSort(sortMode);
                toggleFilter(fiterMode);
                toggleFilter_y(sls_year_id);
                redraw();
            });

function filter(mode, year){
    var exp = [], imp = [];
    if(mode == '#export'){
        for(var item of year){
            if(item.flow == "Export"){
                exp.push(item)
            }        
        }
        current = JSON.parse(JSON.stringify(exp));
    }
    else if (mode === '#import') {
        for(item of year){
            if(item.flow == "Import"){
                imp.push(item)
            }        
        }
        current = JSON.parse(JSON.stringify(imp));
    }
    fiterMode = mode;
    sls_year = year;

}
function sort(mode){
    if(mode == '#country'){
        current.sort((a,b) => d3.descending(a.countryOrArea, b.countryOrArea));
    }else if(mode == '#value'){
        current.sort((a,b) => d3.ascending(a.tradeUsd, b.tradeUsd));
    }
    y.domain(current.map(d => d.countryOrArea));
    sortMode = mode;
}
function toggleSort(id){
    d3.selectAll('.sort')
    .style('background-color', '#eee');
    d3.select(id)
    .style('background-color', 'lightblue');
}
//🚧  implement toggleFilter to highlight buttons with class 'filter' here
function toggleFilter(id) {
    d3.selectAll('.filter')
    .style('background-color', '#eee');
    d3.select(id)
    .style('background-color', 'lightblue');
}
function toggleFilter_y(id) {
    d3.selectAll('.filter_y')
    .style('background-color', '#eee');
    d3.select(id)
    .style('background-color', 'lightblue');
}
function redraw(){
     //update scale
    svg.selectAll('.bar').remove();
    y.domain(current.map(d => d.countryOrArea));
    x.domain([0, d3.max(current, d => d.tradeUsd/10000000000)])
    .range([0, width])  
    ////////////////////////////////
    // DATA JOIN FOR BARS.
    var bars = svg.selectAll('.bar')
        .data(current);
    // UPDATE.
    bars.transition()
        .duration(550)
        .delay(delay)
        .attr('y', d => y(d.countryOrArea))
        .attr('height', y.bandwidth());
    // ENTER.
    // console.log(current)
    bars.enter()
        .append('rect')
        .attr('y', d => y(d.countryOrArea))
        .attr('x', 0)
        .attr('height', y.bandwidth())
        .transition() 
        .duration(550)
        .attr('class', 'bar')
        .attr('x', 0)
        .attr('y', d =>y(d.countryOrArea))
        .attr('height', y.bandwidth())
        .attr('width', d => x(d.tradeUsd/10000000000))
        .attr('fill', "#add8e677")
        .style('opacity', 1);
        // EXIT.
        bars.exit()
        .transition() 
        .duration(550)
        .style('opacity', 0)
        .remove();
        
        ////////////////////////////////
                // DATA JOIN FOR NAMES.
        svg.selectAll('.name').remove();
        var name = svg.selectAll('.name')
        .data(current);
        // UPDATE.
        name.transition()
        .duration(550)
        .delay(delay)
        .attr('y', d => y(d.countryOrArea) + y.bandwidth() / 2);
// ENTER.
    name.enter()
    .append('text')
    .attr('y', d => y(d.countryOrArea))
    .attr('x', d => x(d.tradeUsd/10000000000)+ 45)
    .style('opacity', 0)
    .transition()
    .duration(700)
    .attr('class', 'name')
    .text(d => d.countryOrArea +' '+ d.tradeUsd/10000000000+ "(/10^10 $)")
    .attr('y', d => y(d.countryOrArea) + y.bandwidth() / 2)
    .attr('x', d => x(d.tradeUsd/10000000000) + 45)
    .attr('fill', function(d){
            if(d.countryOrArea == "Japan" || d.countryOrArea == "Italy" || d.countryOrArea == "Finland" || d.countryOrArea == "France" || d.countryOrArea == "Spain"){
              return "#67000d"
            }else if(d.countryOrArea == "United Kingdom" || d.countryOrArea == "Canada" || d.countryOrArea == "USA" || d.countryOrArea == "Australia" || d.countryOrArea == "Iceland"){
              return "#a50f15"
            }
            else if(d.countryOrArea== "China" || d.countryOrArea == "Chile"){
              return "#fb6a4a"
            }
            else if(d.countryOrArea == "Turkey"){
              return "#fc9272"
            }
            else if(d.countryOrArea == "Mexico"){
              return "#fcbba1"
            }
            else{
              return "#000"
            }
          })
    .style('opacity', 1);

    // EXIT.
    name.exit()
    .transition()
    .duration(750)
    .style('opacity', 0)
    .remove();

}
function transition() {
                var transition = svg.transition()
                    .duration(550);

                transition.selectAll('.bar')
                    .delay(delay)
                    .attr('y', d => y(d.countryOrArea));

                transition.selectAll('.name')
                    .delay(delay)
                    .attr('y', d => y(d.countryOrArea) + y.bandwidth() / 2);
            }
    function draw(){
                y.domain(current.map(d => (d.countryOrArea)))
                .range([height, 0])
                .paddingInner(0.2);
                
                x.domain([0, d3.max(current, d => d.tradeUsd/10000000000)])
                .range([0, width])
                
                svg.selectAll('.bar')
                .data(current)
                .enter()
                .append('rect')
                .attr('class', 'bar')
                .attr('y', d => y(d.countryOrArea))
                .attr('x', 0)
                .attr('height', y.bandwidth())
                .attr('width', d => x(d.tradeUsd/10000000000))
                .attr('fill', "#add8e677");
                
                svg.selectAll('.name')
                    .data(current)
                    .enter()
                    .append('text')
                    .text(d => d.countryOrArea +' '+ d.tradeUsd/10000000000 + "(/10^10 $)")
                    .attr('class', 'name')
                    .attr('x', d => x(d.tradeUsd/10000000000)+45)
                    .attr('y', d => y(d.countryOrArea) + y.bandwidth() / 2)
                    .attr('fill', function(d){
            if(d.countryOrArea == "Japan" || d.countryOrArea == "Italy" || d.countryOrArea == "Finland" || d.countryOrArea == "France" || d.countryOrArea == "Spain"){
              return "#67000d"
            }else if(d.countryOrArea == "United Kingdom" || d.countryOrArea == "Canada" || d.countryOrArea == "USA" || d.countryOrArea == "Australia" || d.countryOrArea == "Iceland"){
              return "#a50f15"
            }
            else if(d.countryOrArea== "China" || d.countryOrArea == "Chile"){
              return "#fb6a4a"
            }
            else if(d.countryOrArea == "Turkey"){
              return "#fc9272"
            }
            else if(d.countryOrArea == "Mexico"){
              return "#fcbba1"
            }
            else{
              return "#000"
            }
          });

                yAxis = d3.axisLeft()
                .scale(y)
                .ticks(0)
                .tickSize(0)
                .tickFormat('');

                svg.append('g')
                .attr('class', 'axis')
                .attr('x', margin.left)
                .call(yAxis);

            }
        }}
    }
</script>
<style type="text/css" scoped>
 
        >>> .axis path,
        >>> .axis line {
                fill: none;
                stroke: black;
                shape-rendering: crispEdges;
            }

        >>> .axis text {
                font-family: Courier;
                font-size: 0.85em;
            }

        >>>  text {
                font-family: Courier;
                font-size: 0.65em;
                text-shadow: 1px 1px #ffe63dfa;
            }

         >>> div.commands {
                font-family: Courier;
                font-size: 0.85em;
                font-weight: bold;
                text-align: center;
                cursor: default;
                user-select: none;
            }

          >>> svg {
                display: block;
                margin: auto;
                background-color: #fff;
            }

          /* >>> .bar {
                fill: #add8e677;
            } */

          >>> text.xlabel {
                text-anchor: middle;
            }

           >>> text.ylabel {
                text-anchor: middle;
                alignment-baseline: central;
            }

            >>> text.name {
                font-weight: bold;
                text-anchor: middle;
                alignment-baseline: central;
            }

           >>> .sort {
                border-radius: 3px;
                background-color: #eee;
                display: inline-block;
                cursor: default;
            }

            >>>.sort,
            >>> label {
                font-family: Courier;
                color: #444;
                padding: 5px;
                margin: 5px;
            }

            >>> label {
                vertical-align: text-bottom;
            }

            >>> .filter,
            >>> .filter_y {
                border-radius: 3px;
                background-color: #eee;
                padding: 5px;
                margin: 5px;
                color: #444;
                text-align: left;
                display: inline-block;
                cursor: default;
            }
        </style>